import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/auth.store";

export const AuthRoutes = () => {
  const { authUser: user } = useAuthStore();

  if (user) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};
